import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography, breakpoints }: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    topContent: {
      margin: '20px 0',
    },
    loadingContainer: {
      justifyContent: 'center',
      marginTop: 40,
    },
    hiddenIcon: {
      display: 'none',
    },

    buttonAvatar: {
      display: 'block',
      padding: 5,
      borderRadius: 4,
      border: `1px solid ${palette.gray}`,
      margin: '0 auto 24px',

      '&:disabled': {
        opacity: 0.7,
      },
    },
    avatar: {
      width: 182,
      height: 182,
      background: palette.gray,
      fontSize: 40,
      fontWeight: typography.fontWeightMedium,
      letterSpacing: 3,
    },
    editIcon: {
      position: 'absolute',
      right: 13,
      bottom: 13,
      color: palette.white,
    },

    textName: {
      fontSize: 20,
    },
    textRole: {
      fontWeight: typography.fontWeightMedium,
    },

    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 14,
    },

    buttons: {
      margin: '40px auto',
      justifyContent: 'space-between',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    OKbutton: {
      fontSize: 12,
    },
    OKbuttonText: {
      fontSize: 12,
      fontWeight: 500,
    },
    useNewFront: { fontSize: 12, margin: '2px 0px 5px 9px', fontWeight: 500 },
    fieldset: {
      '& .MuiFormControlLabel-root': {
        marginLeft: 1,
      },
    },
    switch: {
      '& .MuiGrid-spacing-xs-2': {
        margin: '-12px',
      },
    },
    switchPasswordChange: {
      marginTop: 8,
      '& .MuiGrid-spacing-xs-2': {
        margin: '-12px',
      },
    },
    configAD: {
      display: 'flex',
      paddingTop: 20,
    },
    footer: {
      padding: '8px 12px',

      '& .MuiButtonBase-root': {
        textTransform: 'uppercase',
      },
    },
    buttonTest: {
      color: palette.blue,
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },

    header: {
      padding: 12,

      '& .MuiTypography-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,

        '& svg': {
          width: 14,
          height: 14,
        },
      },
    },
    content: {
      flex: 1,
      padding: 12,

      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },
    fieldSetSwitchComponents: {
      border: `1px solid ${palette.borderGray}`,
      borderRadius: 4,
      padding: 5,
      margin: 0,
    },
    fieldSetSwitchText: {
      fontSize: 10,
      fontFamily: 'Roboto',
      color: palette.gray,
      lineHeight: 1,
      fontWeight: 400,
      letterSpacing: 1,
    },
    autocomplete: {
      padding: 8,
      [breakpoints.up('lg')]: {
        width: '50%',
      },
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    formHelperText: { marginBottom: 16 },
    switchRoot: {
      padding: 0,
      margin: 0,
    },
    cloudProviderCards: {
      paddingTop: 20,
      gap: '6px',
    },
    customButton: { borderColor: palette.blue, color: palette.blue },
    autocompleteCompany: {
      fontWeight: 500,
      '& .MuiInputBase-input': {
        cursor: 'pointer',
      },
    },
    selectorGrid: {
      padding: 10,
      [breakpoints.up('lg')]: {
        width: '50%',
      },
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    name: { fontSize: 12 },
    likeCell: {
      width: 20,
      padding: 0,
      textAlign: 'center',

      '& svg': {
        fontSize: 14,
        fill: palette.primary.main,
      },
    },
    tableRow: {
      height: 20,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '& .MuiTableCell-root': {
        padding: '0 0 0 16px',
        color: palette.gray,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    itemSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    selectHeader: { maxWidth: 50 },
    select: { paddingRight: 5 },
    checkIcon: { color: palette.green, width: 15, height: 15 },
    adminBindPassField: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiOutlinedInput-adornedEnd': {
        padding: 0,
      },
      '& .MuiInputAdornment-root': {
        display: 'none',
      },
    },
    changePassButton: {
      marginLeft: 18,
    },

    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      alignItems: 'end',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    manageLicenses: { marginLeft: 8, '& .MuiSvgIcon-root': { fontSize: 20 } },
    disableRecaptchaBox: { marginTop: 16 },
    zeroTrustStatusValid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundLightGreen,
      padding: '4px 12px',
      borderRadius: 16,
    },
    zeroTrustStatusInvalid: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.backgroundSuperLightRed,
      padding: '4px 12px',
      borderRadius: 16,
    },
    statusZeroTrustIconValid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.status.success,
    },
    statusZeroTrustIconInvalid: {
      fontSize: 16,
      marginRight: 6,
      color: palette.red,
    },
    validZeroTrust: {
      color: palette.green,
      fontSize: 16,
    },
    invalidZeroTrust: {
      color: palette.red,
      fontSize: 16,
    },
    itemInfoZeroTrust: { display: 'block' },
    infoZeroTrustTitle: {
      fontSize: 12,
      color: palette.dark,
      display: 'flex',
      margin: 8,
    },
    trueOption: {
      color: palette.green,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
    falseOption: {
      color: palette.red,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
    resultContainer: { display: 'block' },
    itemInfoPlatformVersion: { display: 'block', marginLeft: 32 },
    blueOption: {
      color: palette.blue,
      fontSize: 12,
      marginLeft: 8,
      fontWeight: 550,
    },
  });
